"use client";

import { useState } from "react";
import { Section } from "@/components/core/section/Section";
import { SectionHeader } from "@/components/core/section/SectionHeader";
import Pill from "@/components/core/pill/Pill";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import NextintlLogo from "@/components/logos/nextintl";

const frameworks = ["html", "react", "vue", "svelte", "web"] as const;
const languages = ["en", "fr", "de", "es", "zh", "jp"] as const;

const codeExamples: Record<
  (typeof frameworks)[number],
  Record<(typeof languages)[number], string>
> = {
  react: {
    en: `function About() {
  return (
    <section>
      <h1>About us</h1>
      <p>We build multilingual websites effortlessly.</p>
      <button>Learn more</button>
    </section>
  );
}`,
    fr: `function About() {
  return (
    <section>
      <h1>À propos de nous</h1>
      <p>Nous construisons des sites multilingues sans effort.</p>
      <button>En savoir plus</button>
    </section>
  );
}`,
    de: `function About() {
  return (
    <section>
      <h1>Über uns</h1>
      <p>Wir erstellen mühelos mehrsprachige Websites.</p>
      <button>Mehr erfahren</button>
    </section>
  );
}`,
    es: `function About() {
  return (
    <section>
      <h1>Sobre nosotros</h1>
      <p>Creamos sitios web multilingües sin esfuerzo.</p>
      <button>Saber más</button>
    </section>
  );
}`,
    zh: `function About() {
  return (
    <section>
      <h1>关于我们</h1>
      <p>我们轻松构建多语言网站。</p>
      <button>了解更多</button>
    </section>
  );
}`,
    jp: `function About() {
  return (
    <section>
      <h1>私たちについて</h1>
      <p>多言語対応のウェブサイトを簡単に構築します。</p>
      <button>詳しくはこちら</button>
    </section>
  );
}`,
  },
  vue: {
    en: `<template>
  <section>
    <h1>About us</h1>
    <p>We build multilingual websites effortlessly.</p>
    <button>Learn more</button>
  </section>
</template>`,
    fr: `<template>
  <section>
    <h1>À propos de nous</h1>
    <p>Nous construisons des sites multilingues sans effort.</p>
    <button>En savoir plus</button>
  </section>
</template>`,
    de: `<template>
  <section>
    <h1>Über uns</h1>
    <p>Wir erstellen mühelos mehrsprachige Websites.</p>
    <button>Mehr erfahren</button>
  </section>
</template>`,
    es: `<template>
  <section>
    <h1>Sobre nosotros</h1>
    <p>Creamos sitios web multilingües sin esfuerzo.</p>
    <button>Saber más</button>
  </section>
</template>`,
    zh: `<template>
  <section>
    <h1>关于我们</h1>
    <p>我们轻松构建多语言网站。</p>
    <button>了解更多</button>
  </section>
</template>`,
    jp: `<template>
  <section>
    <h1>私たちについて</h1>
    <p>多言語対応のウェブサイトを簡単に構築します。</p>
    <button>詳しくはこちら</button>
  </section>
</template>`,
  },
  svelte: {
    en: `<section>
  <h1>About us</h1>
  <p>We build multilingual websites effortlessly.</p>
  <button>Learn more</button>
</section>`,
    fr: `<section>
  <h1>À propos de nous</h1>
  <p>Nous construisons des sites multilingues sans effort.</p>
  <button>En savoir plus</button>
</section>`,
    de: `<section>
  <h1>Über uns</h1>
  <p>Wir erstellen mühelos mehrsprachige Websites.</p>
  <button>Mehr erfahren</button>
</section>`,
    es: `<section>
  <h1>Sobre nosotros</h1>
  <p>Creamos sitios web multilingües sin esfuerzo.</p>
  <button>Saber más</button>
</section>`,
    zh: `<section>
  <h1>关于我们</h1>
  <p>我们轻松构建多语言网站。</p>
  <button>了解更多</button>
</section>`,
    jp: `<section>
  <h1>私たちについて</h1>
  <p>多言語対応のウェブサイトを簡単に構築します。</p>
  <button>詳しくはこちら</button>
</section>`,
  },
  web: {
    en: `<section>
  <h1>About us</h1>
  <p>We build multilingual websites effortlessly.</p>
  <button>Learn more</button>
</section>`,
    fr: `<section>
  <h1>À propos de nous</h1>
  <p>Nous construisons des sites multilingues sans effort.</p>
  <button>En savoir plus</button>
</section>`,
    de: `<section>
  <h1>Über uns</h1>
  <p>Wir erstellen mühelos mehrsprachige Websites.</p>
  <button>Mehr erfahren</button>
</section>`,
    es: `<section>
  <h1>Sobre nosotros</h1>
  <p>Creamos sitios web multilingües sin esfuerzo.</p>
  <button>Saber más</button>
</section>`,
    zh: `<section>
  <h1>关于我们</h1>
  <p>我们轻松构建多语言网站。</p>
  <button>了解更多</button>
</section>`,
    jp: `<section>
  <h1>私たちについて</h1>
  <p>多言語対応のウェブサイトを簡単に構築します。</p>
  <button>詳しくはこちら</button>
</section>`,
  },
  html: {
    en: `<section>
  <h1>About us</h1>
  <p>We build multilingual websites effortlessly.</p>
  <button>Learn more</button>
</section>`,
    fr: `<section>
  <h1>À propos de nous</h1>
  <p>Nous construisons des sites multilingues sans effort.</p>
  <button>En savoir plus</button>
</section>`,
    de: `<section>
  <h1>Über uns</h1>
  <p>Wir erstellen mühelos mehrsprachige Websites.</p>
  <button>Mehr erfahren</button>
</section>`,
    es: `<section>
  <h1>Sobre nosotros</h1>
  <p>Creamos sitios web multilingües sin esfuerzo.</p>
  <button>Saber más</button>
</section>`,
    zh: `<section>
  <h1>关于我们</h1>
  <p>我们轻松构建多语言网站。</p>
  <button>了解更多</button>
</section>`,
    jp: `<section>
  <h1>私たちについて</h1>
  <p>多言語対応のウェブサイトを簡単に構築します。</p>
  <button>詳しくはこちら</button>
</section>`,
  },
};

export default function International() {
  const [framework, setFramework] =
    useState<(typeof frameworks)[number]>("react");
  const [language, setLanguage] = useState<(typeof languages)[number]>("en");

  return (
    <div className="max-w-4xl mx-auto">
      <Section size="md">
        <SectionHeader
          title={
            <>
              Internationalisation
              <br />
              Multilingual & Multiplatform made easy
            </>
          }
          description="Raffaello can generate web pages and components for nearly any framework or language."
        />

        <div className="grid max-w-5xl gap-6 mx-auto md:grid-cols-2">
          {/* Code Block */}
          <div className="flex order-2 overflow-hidden md:order-1">
            <div className="flex flex-col w-full border rounded-lg bg-gradient-to-b from-slate-800/60 to-card/20 backdrop-blur-sm border-border/20">
              <Tabs
                value={framework}
                onValueChange={(val) => setFramework(val as any)}
                className="w-full"
              >
                <div className="relative flex justify-center w-full p-4">
                  <span className="absolute w-4 h-4 transition-all rounded-full left-4 top-5 bg-indigo-400/15 hover:bg-red-400" />
                  <span className="absolute w-4 h-4 transition-all rounded-full left-9 top-5 bg-indigo-400/15 hover:bg-yellow-400" />
                  <span className="absolute w-4 h-4 transition-all rounded-full left-14 top-5 bg-indigo-400/15 hover:bg-green-400" />

                  <TabsList className="h-auto p-0 mx-auto bg-transparent text-inherit -my-1.5">
                    {frameworks.map((fw) => (
                      <TabsTrigger
                        key={fw}
                        value={fw}
                        className={`m-0 text-sm md:text-base capitalize data-[state=active]:bg-background/50 data-[state=active]:text-purple-400`}
                      >
                        <b>{fw}</b>
                      </TabsTrigger>
                    ))}
                  </TabsList>
                </div>
                {frameworks.map((fw) => (
                  <TabsContent key={fw} value={fw} className="w-full">
                    <code className="flex w-full p-4 pb-7">
                      <pre className="overflow-x-scroll whitespace-pre-wrap text-sm font-mono text-left text-card-foreground">
                        {codeExamples[fw][language]}
                      </pre>
                    </code>
                  </TabsContent>
                ))}
              </Tabs>
            </div>
          </div>

          {/* Language & Framework Pills */}
          <div className="flex flex-col items-center justify-center order-1 gap-6 md:order-2">
            {/* <NextintlLogo className="h-9" /> */}
            <div className="flex flex-wrap justify-center gap-3 p-4">
              {languages.map((lang) => (
                <Pill
                  key={lang}
                  onClick={() => setLanguage(lang)}
                  className={`cursor-pointer ${lang === language ? "bg-purple-600 text-white" : ""}`}
                >
                  <b className="font-poppins">
                    {
                      {
                        en: "🇬🇧 Welcome",
                        fr: "🇫🇷 Bienvenue",
                        de: "🇩🇪 Willkommen",
                        es: "🇪🇸 Bienvenido",
                        zh: "🇨🇳 欢迎",
                        jp: "🇯🇵 ようこそ",
                      }[lang]
                    }
                  </b>
                </Pill>
              ))}
            </div>
            {/* 
            <div className="flex flex-wrap justify-center gap-3 px-4 pb-2">
              {frameworks.map((fw) => (
                <Pill
                  key={fw}
                  onClick={() => setFramework(fw)}
                  className={`cursor-pointer capitalize ${fw === framework ? "bg-purple-600 text-white" : ""}`}
                >
                  {fw}
                </Pill>
              ))}
            </div> */}
          </div>
        </div>
      </Section>
    </div>
  );
}
